import React, { useEffect, useState } from 'react';
import { Container, Card, CardBody } from 'reactstrap';
import { useNavigate } from 'react-router-dom';
import { useTranslation } from 'react-i18next';
import { useSelector, useDispatch } from 'react-redux';
import Swal from 'sweetalert2';
import {
  FaTachometerAlt,
  FaBoxes,
  FaShoppingCart,
  FaShoppingBasket,
  FaCalculator,
  FaCog,
  FaUserCircle,
  FaSignOutAlt,
  FaMoon,
  FaSun,
  FaClock,
  FaHandHoldingUsd
} from 'react-icons/fa';
import { authActions } from '../../sagas/authSlice';
import './ModuleSelector.css';

const ModuleSelector = () => {
  const { t } = useTranslation();
  const navigate = useNavigate();
  const dispatch = useDispatch();
  const { fullName, businessName } = useSelector(state => state.auth);

  const [darkMode, setDarkMode] = useState(false);

  const modules = [
    { title: t('modules.dashboard.title'), icon: FaTachometerAlt, route: '/dashboard' },
    { title: t('modules.inventory.title'), icon: FaBoxes, route: '/inventory-module' },
    { title: t('modules.pos.title'), icon: FaShoppingCart, route: '/pos-module' },

    { title: t('modules.shifts.title'), icon: FaClock, route: '/shifts-module' },

    { title: t('modules.sales.title'), icon: FaShoppingCart, route: '/sales-module' },
    { title: t('modules.purchases.title'), icon: FaShoppingBasket, route: '/purchases-module' },

    // ✅ NEW: RECOUVREMENT
    { title: t('modules.recouvrement.title'), icon: FaHandHoldingUsd, route: '/recouvrement-module' },

    { title: t('modules.settings.title'), icon: FaCog, route: '/settings-module' },
  ];

  /* ===== Keyboard shortcuts 1–9 ===== */
  useEffect(() => {
    const onKey = (e) => {
      const idx = Number(e.key) - 1;
      if (idx >= 0 && idx < modules.length) {
        navigate(modules[idx].route);
      }
    };
    window.addEventListener('keydown', onKey);
    return () => window.removeEventListener('keydown', onKey);
  }, [navigate]);

  /* ===== Dark mode ===== */
  useEffect(() => {
    document.body.classList.toggle('dark-mode', darkMode);
  }, [darkMode]);

  const handleLogout = () => {
    Swal.fire({
      title: 'Confirmer la déconnexion',
      icon: 'warning',
      showCancelButton: true,
      confirmButtonText: 'Se déconnecter',
      cancelButtonText: 'Annuler'
    }).then((r) => {
      if (r.isConfirmed) {
        dispatch(authActions.logout());
        localStorage.clear();
        navigate('/login');
      }
    });
  };

  return (
    <div className="module-selector-wrapper">

      {/* HERO */}
      <div className="hero-section">
        <Container className="hero-content-centered">
          <h2 className="hero-title">
            {t('modules.welcome', { businessName })}
          </h2>

          <div className="hero-right">
            <button
              className="theme-toggle"
              onClick={() => setDarkMode(v => !v)}
            >
              {darkMode ? <FaSun /> : <FaMoon />}
            </button>

            <div className="user-pill">
              <FaUserCircle />
              <span>{fullName}</span>
            </div>

            <button className="logout-btn" onClick={handleLogout}>
              <FaSignOutAlt />
              <span>Déconnexion</span>
            </button>
          </div>
        </Container>
      </div>

      {/* MODULES */}
      <Container className="modules-container">
        <div className="modules-row auto-scale">
          {modules.map((m, i) => (
            <Card
              key={i}
              className={`module-card-dense ${m.primary ? 'primary' : ''}`}
              onClick={() => navigate(m.route)}
            >
              <CardBody className="module-card-body-dense">
                <span className="shortcut">{i + 1}</span>
                <m.icon size={30} />
                <div className="module-title-dense">{m.title}</div>
              </CardBody>
            </Card>
          ))}
        </div>
      </Container>

      {/* FOOTER */}
      <footer className="app-footer">
        <Container className="footer-content">
          <span><strong>{businessName}</strong> — ERP & POS</span>
          <span>© {new Date().getFullYear()}</span>
          <span>Powered by <strong>IDERACLOUD</strong></span>
        </Container>
      </footer>

    </div>
  );
};

export default ModuleSelector;
